// // utils/locationUtils.js

// export const getDistanceInKm = (lat1, lon1, lat2, lon2) => {
//   const R = 6371; // Earth radius (KM)
//   const dLat = (lat2 - lat1) * Math.PI / 180;
//   const dLon = (lon2 - lon1) * Math.PI / 180;

//   const a =
//     Math.sin(dLat / 2) ** 2 +
//     Math.cos(lat1 * Math.PI / 180) *
//       Math.cos(lat2 * Math.PI / 180) *
//       Math.sin(dLon / 2) ** 2;

//   return R * 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
// };

// export const findNearestSite = (lat, lng, sites, maxDistance = 2) => {
//   let nearest = null;
//   let minDistance = Infinity;

//   for (let site of sites) {
//     if (!site.latitude || !site.longitude) continue;

//     const dist = getDistanceInKm(
//       lat,
//       lng,
//       site.latitude,
//       site.longitude
//     );

//     if (dist <= maxDistance && dist < minDistance) {
//       minDistance = dist;
//       nearest = site;
//     }
//   }
//   return nearest;
// };



// utils/locationUtils.js

export const getDistanceInKm = (lat1, lon1, lat2, lon2) => {
  const R = 6371; // Earth radius (KM)

  const dLat = (lat2 - lat1) * Math.PI / 180;
  const dLon = (lon2 - lon1) * Math.PI / 180;

  const a =
    Math.sin(dLat / 2) ** 2 +
    Math.cos(lat1 * Math.PI / 180) *
      Math.cos(lat2 * Math.PI / 180) *
      Math.sin(dLon / 2) ** 2;

  return R * 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
};

export const findNearestSite = (lat, lng, sites, maxDistance = 400) => {
  let nearest = null;
  let minDistance = Infinity;

  const currentLat = Number(lat);
  const currentLng = Number(lng);

  console.log("lat, lang", currentLat, currentLng)

  for (let site of sites) {
    const siteLat = Number(site.latitude);
    const siteLng = Number(site.longitude);

    if (
      isNaN(currentLat) ||
      isNaN(currentLng) ||
      isNaN(siteLat) ||
      isNaN(siteLng)
    ) continue;

    const dist = getDistanceInKm(
      currentLat,
      currentLng,
      siteLat,
      siteLng
    );

    console.log(
      `Site: ${site.name} → ${dist.toFixed(3)} KM`
    );

    if (dist <= maxDistance && dist < minDistance) {
      minDistance = dist;
      nearest = site;
    }
  }

  return nearest;
};
